import * as yup from 'yup';

export const registrationFormValidationSchema = yup.object({
  firstName: yup.string().required('Podaj imię'),
  lastName: yup.string().required('Podaj nazwisko'),
  email: yup
    .string()
    .email('Niepoprawny adres e-mail')
    .required('Podaj adres e-mail'),
  password: yup
    .string()
    .min(8, 'Hasło musi zawierać minimum 8 znaków')
    .required('Podaj hasło'),
  passwordConfirm: yup
    .string()
    .oneOf([yup.ref('password')], 'Hasła muszą być takie same')
    .required('Powtórz hasło'),
});

export const loginFormValidationSchema = yup.object({
  email: yup
    .string()
    .email('Niepoprawny adres e-mail')
    .required('Podaj adres e-mail'),
  password: yup.string().required('Podaj hasło'),
});

export const resetFormValidationSchema = yup.object({
  email: yup
    .string()
    .email('Niepoprawny adres e-mail')
    .required('Podaj adres e-mail'),
});

export const createNewPasswordFormValidationSchema = yup.object({
  email: yup
    .string()
    .email('Niepoprawny adres e-mail')
    .required('Podaj adres e-mail'),
  password: yup.string().required('Podaj hasło'),
  passwordConfirm: yup
    .string()
    .oneOf([yup.ref('password')], 'Hasła muszą być takie same')
    .required('Powtórz hasło'),
});

export const addressValidationSchema = yup.object({
  form: yup.string(),
  first_name: yup.string().when('form', {
    is: 'personal',
    then: schema => schema.required('Podaj imię'),
    otherwise: schema => schema.nullable(),
  }),
  last_name: yup.string().when('form', {
    is: 'personal',
    then: schema => schema.required('Podaj nazwisko'),
    otherwise: schema => schema.nullable(),
  }),
  company: yup.string().when('form', (form, schema) => {
    if (form.includes('company')) {
      return schema.required('Podaj nazwę firmy');
    }

    return schema;
  }),
  nip: yup.string().when('form', (form, schema) => {
    if (form.includes('company')) {
      return schema.min(10, 'NIP jest za krótki').required('Podaj NIP');
    }

    return schema;
  }),
  address_1: yup.string().required('Podaj ulicę'),
  address_2: yup.string().required('Podaj numer budynku'),
  city: yup.string().required('Podaj nazwę miasta'),
  postal_code: yup.string().required('Podaj kod pocztowy'),
  phone: yup.string().required('Podaj numer telefonu'),
});

const billingAddressValidationSchema = yup.lazy(value => {
  if (value.checked) {
    return yup.object({
      form: yup.string(),
      first_name: yup.string().when('form', {
        is: 'personalBilling',
        then: schema => schema.required('Podaj imię'),
        otherwise: schema => schema.nullable(),
      }),
      last_name: yup.string().when('form', {
        is: 'personalBilling',
        then: schema => schema.required('Podaj nazwisko'),
        otherwise: schema => schema.nullable(),
      }),
      company: yup.string().when('form', (form, schema) => {
        if (form.includes('companyBilling')) {
          return schema.required('Podaj nazwę firmy');
        }

        return schema;
      }),
      nip: yup.string().when('form', (form, schema) => {
        if (form.includes('companyBilling')) {
          return schema.min(10, 'NIP jest za krótki').required('Podaj NIP');
        }

        return schema;
      }),
      address_1: yup.string().required('Podaj ulicę'),
      address_2: yup.string().required('Podaj numer budynku'),
      city: yup.string().required('Podaj nazwę miasta'),
      postal_code: yup.string().required('Podaj kod pocztowy'),
      phone: yup.string().required('Podaj numer telefonu'),
    });
  } else {
    return yup.object().nullable();
  }
});

export const checkoutFormValidationSchema = yup.object({
  email: yup
    .string()
    .email('Niepoprawny adres e-mail')
    .required('Podaj adres e-mail'),
  shipping_address: addressValidationSchema,
  billing_address: billingAddressValidationSchema,
});

export const personValidationSchema = yup.object({
  first_name: yup.string().required('Podaj imię'),
  last_name: yup.string().required('Podaj nazwisko'),
});

export const companyValidationSchema = yup.object({
  company: yup.string().optional(),
});

export const addressOtherValidationSchema = yup.object({
  address_1: yup.string().required('Podaj ulicę'),
  address_2: yup.string().required('Podaj numer budynku'),
  city: yup.string().required('Podaj nazwę miasta'),
  postal_code: yup.string().required('Podaj kod pocztowy'),
  phone: yup.string().required('Podaj numer telefonu'),
});

export const changePasswordFormValidationSchema = yup.object({
  password: yup
    .string()
    .min(8, 'Hasło musi zawierać minimum 8 znaków')
    .required('Podaj hasło'),
  newPassword: yup
    .string()
    .min(8, 'Hasło musi zawierać minimum 8 znaków')
    .required('Podaj nowe hasło'),
  newPasswordConfirm: yup
    .string()
    .oneOf([yup.ref('newPassword')], 'Hasła muszą być takie same')
    .required('Powtórz nowe hasło'),
});

export const editCustomerDataFormValidationSchema = yup.object({
  first_name: yup.string().required('Podaj imię'),
  last_name: yup.string().required('Podaj nazwisko'),
  email: yup
    .string()
    .email('Niepoprawny adres e-mail')
    .required('Podaj adres e-mail'),
});

export const newsletterValidationSchema = yup.object({
  email: yup
    .string()
    .email('Niepoprawny adres e-mail')
    .required('Podaj adres e-mail'),
});
